import { NavLink, useLocation } from "react-router-dom";
import { iRoute } from "../../types/routes";
import routes from "../../routes";
import BreadCrumbItem from "./BreadCrumbItem";
// import styles from "./bread-crumb.module.scss";
import styles from "./breadcrumbs.module.scss";
interface iBreadCrumb {
  pathname: string;
  name: string;
  active: boolean;
}

function AppBreadcrumb() {
  function getRouteName(pathname: string, routes: iRoute[]): string {
    const currentRoute = routes.find((route) => route.path === pathname);
    return currentRoute ? currentRoute.name : "";
  }

  function getBreadCrumbs(location: string): iBreadCrumb[] {
    const breadcrumbs: Array<iBreadCrumb> = [];
    location.split("/").reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`;
      const routeName = getRouteName(currentPathname, routes);
      routeName &&
        breadcrumbs.push({
          pathname: currentPathname,
          name: routeName,
          active: index + 1 === array.length ? true : false,
        });
      return currentPathname;
    });

    return breadcrumbs;
  }

  const current_location = useLocation().pathname; //getCurrentLocation()
  const breadcrumbs: iBreadCrumb[] = getBreadCrumbs(current_location);
  return (
    <div className={styles.breadcrumbs}>
      {/* <NavLink
        to="/"
        className="text-teal-800 font-bold text-md hover:text-blue-600"
      >
        Dashboard <span>/</span>
      </NavLink> */}

      {breadcrumbs.map((breadcrumb, key) => (
        <BreadCrumbItem
          key={key}
          name={breadcrumb.name}
          path={breadcrumb.pathname}
          active={true}
        />
      ))}
    </div>
  );
}

export default AppBreadcrumb;
